import { useIntl } from 'react-intl';

import { SMBC_SIMULATION_URL } from '@/lib/const';
import { PAYMENT_TYPES } from '@/lib/payment/types';
import * as M from '@/views/PaymentView/components/SmbcPayment/messages';

import { openSimulation } from './helper';
import * as S from './SmbcSentence.style';

import SmbcFinancingIcon from '@/assets/payment_methods/smbc-full.svg';

export const SmbcSentence = () => {
  const { formatMessage } = useIntl();

  const openSmbcSimulation = () => {
    openSimulation(SMBC_SIMULATION_URL, 580, 600, PAYMENT_TYPES.SMBC);
  };

  return (
    <S.FinancingContainer>
      <span>{formatMessage(M.defined.installmentInfo)}</span>
      <S.Image
        alt='smbc_financing'
        height={20}
        src={SmbcFinancingIcon}
        width={134}
      />
      <S.StyledLink
        onClick={openSmbcSimulation}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            openSmbcSimulation();
          }
        }}
        role='button'
        tabIndex={0}
      >
        {formatMessage(M.defined.installmentInfoCTA)}
      </S.StyledLink>
    </S.FinancingContainer>
  );
};
